export const catalog_matrix = [
    {form_key:'responsible_id', catalog_key:'none', propname:'users'},
    {form_key:'process_status_id', catalog_key:'process_statuses'},
]